var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltips"},[_c('button',{staticClass:"helpButton",on:{"click":function($event){_vm.openHelp(_vm.helpbookmark), _vm.$tera.project.TrialWizard.helpToggle = !_vm.$tera.project.TrialWizard.helpToggle}}},[_vm._v("?")]),_c('span',{staticClass:"tooltiptext"},[_vm._v("Help")])])
}
var staticRenderFns = []

export { render, staticRenderFns }